import { createSafeActionClient } from 'next-safe-action'
import { z } from 'zod'

import { COMMON, isHttpError, MessageType } from '@/shared/api'

import { logError, logInfo, logSuccess } from './logger'

const DEFAULT_MESSAGE =
  '처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.'

export const action = createSafeActionClient({
  defineMetadataSchema() {
    return z.object({
      actionName: z.string(),
    })
  },
  handleServerError(error, utils) {
    // 서버 에러는 이 함수에서 별도로 처리 → 에러 대신 핸들러를 반환
    // 미들웨어에서는 서버 에러 객체를 확인할 수 없으므로 따로 로깅
    logError({
      json: error,
      actionName: utils.metadata.actionName,
    })

    if (isHttpError(error)) {
      return error.handler
    }

    return {
      code: COMMON['001'],
      type: MessageType.TOAST,
      content: DEFAULT_MESSAGE,
    }
  },
}).use(async ({ next, clientInput, metadata }) => {
  logInfo({
    json: clientInput,
    actionName: metadata.actionName,
  })

  const result = await next()

  if (result.success) {
    logSuccess({
      json: result.data,
      actionName: metadata.actionName,
    })
  }

  return result
})
